import { render } from "./ArticleAtom.vue?vue&type=template&id=11cda154&scoped=true"
import script from "./ArticleAtom.vue?vue&type=script&lang=js"
export * from "./ArticleAtom.vue?vue&type=script&lang=js"

import "./ArticleAtom.vue?vue&type=style&index=0&id=11cda154&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cda154"]])

export default __exports__